"use client";
import { configStore } from "@/store/configStore";
import { observer } from "mobx-react-lite";
import React from "react";
import { DefaultAnnouncement } from "./DefaultAnnouncement";

export const AnnouncementBar: React.FC = observer(() => {
  const config = configStore.bannerConfig.homeTop;

  if (!config) {
    return null;
  }

  if (config.type === "default") {
    return <DefaultAnnouncement config={config} />;
  }

  return null;
});
